enum CartStep {
    CART,
    PROCESS_ORDER,
    RECEIVE_ORDER
}

export default CartStep;